import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useSubmitMenuItem } from '../../../useSubmitMenuItem';
import s from './SubmitMenuItem.scss';
var SubmitMenuItem = function (_a) {
    var className = _a.className, type = _a.type, modalType = _a.modalType, modalOptions = _a.modalOptions, label = _a.label, link = _a.link, target = _a.target, verificationAction = _a.verificationAction, isLegacyHeader = _a.isLegacyHeader;
    var t = useTranslation().t;
    var _b = useSubmitMenuItem({
        modalType: modalType,
        link: link,
        verificationAction: verificationAction,
        type: type,
        modalOptions: modalOptions,
        isLegacyHeader: isLegacyHeader,
    }), onClick = _b.onClick, href = _b.href, biData = _b.biData;
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['submit-menu-item'], className), href: href, target: target, tabIndex: 0, onClick: onClick, biData: biData, isFakeButton: !onClick }, t(label)));
};
SubmitMenuItem.displayName = 'SubmitMenuItem';
export default SubmitMenuItem;
//# sourceMappingURL=SubmitMenuItem.js.map